export const MODAL_CLOSE_EVENT = "gw_modal_close";
